import { Injectable } from '@angular/core';
import { NgbDatepickerI18nDefault } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class KnBrTwoLetterWeekdayDatepickerI18nService extends NgbDatepickerI18nDefault {
  override getWeekdayLabel(
    weekday: number,
    width: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined> = 'narrow'
  ): string {
    if (width === 'long') {
      return super.getWeekdayLabel(weekday, width);
    }

    const shortWeekday = super.getWeekdayLabel(weekday, 'short');
    if (!shortWeekday) {
      return shortWeekday;
    }

    return shortWeekday.length <= 2 ? shortWeekday : shortWeekday.slice(0, 2);
  }
}
